import { Component, OnInit, Output, Input, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { GlobalService } from '../../../shared/services/global.service';
import { FilterService } from '../../../shared/services/filter.service';
@Component({
    selector: 'app-order-table',
    templateUrl: './order-table.component.html',
    styleUrls: ['./order-table.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OrderTableComponent implements OnInit {
	@Input() orderItems: any;
	@Input() minNumber: number;
	@Output() closeView = new EventEmitter<string>();
	@Output() notify = new EventEmitter<string>();

	viewOrderItems: any;

	close() {
		this.closeView.emit()
	}
	changeOrder(item, pos) {
		if (item.order && item.old_order >= this.minNumber) {
			if (item.order < this.minNumber) {
				item.order = this.minNumber
			} else if (item.order > this.viewOrderItems.length) {
				item.order = this.viewOrderItems.length
			}

			if (parseInt(item.old_order) > parseInt(item.order)) {
				// if new order is smaller
				var a = this.viewOrderItems.slice((parseInt(item.order) - 1), (parseInt(item.old_order) - 1));
				for (let lit of a) {
					lit.order = parseInt(lit.old_order) + 1;
					lit.old_order = lit.order;
				}
			} else if (parseInt(item.old_order) < parseInt(item.order)) {
				// if new order is bigger
				var a = this.viewOrderItems.slice(parseInt(item.old_order), parseInt(item.order));
				for (let lit of a) {
					lit.order = parseInt(lit.old_order) - 1;
					lit.old_order = lit.order;
				}
			}

			item.old_order = item.order
			this.viewOrderItems.sort((a, b) => parseInt(a.order) < parseInt(b.order) ? -1 : parseInt(b.order) < parseInt(a.order) ? 1 : 0);
		} else {
			item.order = item.old_order
		}

	}
	submitForm() {
		this.notify.emit(this.viewOrderItems)
	}

	constructor(public _gS: GlobalService, private _fS: FilterService) { }

	ngOnInit() {
		this.viewOrderItems = JSON.parse(JSON.stringify(this.orderItems));
		for (let itm of this.viewOrderItems) {
			itm.old_order = itm.order
		}
	}

}